export function createFloatingParticles(count, config) {
  const {
    sizeMin = 10,
    sizeRange = 11,
    startXMin = 35,
    startXRange = 72,
    driftMin = -28,
    driftRange = 30,
    durationMin = 8,
    durationRange = 6,
    delayMax = 12,
    spinMin = 180,
    spinRange = 540,
    opacityMin = 0.35,
    opacityRange = 0.35,
  } = config;

  return Array.from({ length: count }, (_, i) => ({
    id: i,
    size: sizeMin + (i * 7 + 3) % sizeRange,
    startX: startXMin + (i * 17 + 5) % startXRange,
    delay: ((i * 1.7) % delayMax).toFixed(2),
    duration: (durationMin + (i * 0.9) % durationRange).toFixed(2),
    drift: (driftMin - (i * 7) % driftRange).toFixed(1),
    spin: spinMin + (i * 97) % spinRange,
    opacity: (opacityMin + (i * 0.03) % opacityRange).toFixed(2),
  }));
}
